import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'

const PublicRoute = ({ children }) => {
  const { user, loading, isPasswordReset } = useAuth()
  const location = useLocation()

  // Wait for authentication check to complete before making routing decisions
  if (loading) {
    return children // Show loading state (handled by login page's loading indicator)
  }

  // If user is in password reset flow, only allow access to reset-password page
  if (isPasswordReset) {
    if (location.pathname === '/reset-password') {
      return children
    }
    return <Navigate to="/reset-password" replace />
  }

  // If user is authenticated (not in password reset), redirect to home page
  if (user) {
    return <Navigate to="/" replace />
  }

  // If user is not authenticated, render the public route
  return children
}

export default PublicRoute 